import { render, staticRenderFns } from "./xuankeyuanxiao.vue?vue&type=template&id=78589e1a&scoped=true"
import script from "./xuankeyuanxiao.vue?vue&type=script&lang=js"
export * from "./xuankeyuanxiao.vue?vue&type=script&lang=js"
import style0 from "./xuankeyuanxiao.vue?vue&type=style&index=0&id=78589e1a&prod&lang=less&scoped=true"
import style1 from "./xuankeyuanxiao.vue?vue&type=style&index=1&id=78589e1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78589e1a",
  null
  
)

export default component.exports